import { useEffect } from "react";

const useIntercomStyles = () => {
  /**
   * Adds the 'intercom-overwrite' class to the body element when the component mounts.
   * This class is used to overwrite the position of the Intercom bubble.
   *
   * The cleanup function removes the 'intercom-overwrite' class from the body element
   * when the component unmounts, ensuring that the styles are scoped and do not affect
   * other parts of the application.
   */
  useEffect(() => {
    document.body.classList.add("intercom-overwrite");

    return () => {
      document.body.classList.remove("intercom-overwrite");
    };
  }, []);

  /**
   * Adds the 'intercom-namespace-hover' class to the .intercom-namespace element
   * when the element with the ID 'next-button-booking' is hovered.
   */
  useEffect(() => {
    const nextButton = document.getElementById("next-button-booking");

    const handleMouseEnter = () => {
      const intercomNamespace = document.querySelector(".intercom-namespace div");
      if (intercomNamespace) {
        intercomNamespace.classList.add("intercom-namespace-hover");
      }
    };

    const handleMouseLeave = () => {
      const intercomNamespace = document.querySelector(".intercom-namespace div");
      if (intercomNamespace) {
        intercomNamespace.classList.remove("intercom-namespace-hover");
      }
    };

    if (nextButton) {
      nextButton.addEventListener("mouseenter", handleMouseEnter);
      nextButton.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (nextButton) {
        nextButton.removeEventListener("mouseenter", handleMouseEnter);
        nextButton.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);
};
export default useIntercomStyles;
